export const GOAL_CATEGORIES = ["Personal", "Professional", "Health", "Financial", "Mental", "Relationships", "Creative", "Learning"] as const;
export type GoalCategory = typeof GOAL_CATEGORIES[number];
export function goalProgress(goal: { is_completed?: boolean; progress_override: number | null; milestones: { is_done: boolean }[] }) {
  if (goal.is_completed) return 100;
  if (goal.progress_override != null) return Math.max(0, Math.min(100, goal.progress_override));
  return goal.milestones.length ? Math.round(goal.milestones.filter(m => m.is_done).length / goal.milestones.length * 100) : 0;
}
export function goalDate(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}
export function validGoalDate(value: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T12:00:00`);
  return !Number.isNaN(date.getTime()) && goalDate(date) === value;
}
/** Civil days, independent of time of day and daylight-saving transitions. */
export function goalDaysLeft(value: string | null, now = new Date()): number | null {
  if (!value || !validGoalDate(value)) return null;
  return Math.round((Date.parse(`${value}T00:00:00Z`) - Date.parse(`${goalDate(now)}T00:00:00Z`)) / 86400000);
}
export function goalMonthsFromNow(months: number, now = new Date()) {
  const date = new Date(now.getFullYear(), now.getMonth() + months + 1, 0, 12);
  date.setDate(Math.min(now.getDate(), date.getDate())); return goalDate(date);
}
/** crypto.randomUUID is unavailable on early iOS 15. */
export function newGoalId() {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
